import { createContext } from 'react';

export const ThemeContext = createContext('light');
export const GoogleOauthContext = createContext(false);